import type { MatrixAmount, MatrixAmountUnit } from 'prove-common'

export type MatrixAmountDraft = {
  value: string
  unit: MatrixAmountUnit | ''
}

export const emptyMatrixAmountDraft: MatrixAmountDraft = { value: '', unit: '' }

export const toMatrixAmountDraft = (
  amount?: MatrixAmount | null
): MatrixAmountDraft =>
  amount == null
    ? emptyMatrixAmountDraft
    : { value: String(amount.value), unit: amount.unit }

/** Must match MATRIX_AMOUNT_UPPER_BOUND in backend TaskService (exclusive). */
const MATRIX_AMOUNT_UPPER_BOUND = 100_000_000

const hasMoreThanTwoDecimals = (rawValue: string): boolean =>
  /\.\d{3,}$/.test(rawValue)

export type MatrixAmountResult = {
  amount: MatrixAmount | null
  error?: string
}

/** Both value and unit, or neither. Value must be > 0 with max two decimals. */
export const parseMatrixAmountDraft = (
  draft: MatrixAmountDraft
): MatrixAmountResult => {
  const rawValue = draft.value.trim().replace(',', '.')
  if (rawValue === '' && draft.unit === '') return { amount: null }
  if (rawValue === '' || draft.unit === '') {
    return {
      amount: null,
      error: 'Oppgi både mengde og enhet, eller ingen av dem'
    }
  }
  if (/e/i.test(rawValue)) {
    return { amount: null, error: 'Mengde må være større enn 0' }
  }
  const value = Number(rawValue)
  if (!Number.isFinite(value) || value <= 0) {
    return { amount: null, error: 'Mengde må være større enn 0' }
  }
  if (value >= MATRIX_AMOUNT_UPPER_BOUND) {
    return { amount: null, error: 'Mengde må være mindre enn 100 000 000' }
  }
  if (hasMoreThanTwoDecimals(rawValue)) {
    return { amount: null, error: 'Mengde kan ha maks to desimaler' }
  }
  return { amount: { value, unit: draft.unit } }
}
